"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentWidthFromDesignConfig = exports.getBackgroundColorFromDesignConfig = void 0;
const getBackgroundColorFromDesignConfig = (designConfig) => {
    // Check Waypoint structure first (root.data.backdropColor)
    const waypointBackdrop = designConfig?.["root"];
    if (waypointBackdrop?.data?.backdropColor) {
        return waypointBackdrop.data.backdropColor;
    }
    // Fall back to Unlayer structure (body.values.backgroundColor)
    return designConfig?.["body"]?.["values"]?.["backgroundColor"] ?? undefined;
};
exports.getBackgroundColorFromDesignConfig = getBackgroundColorFromDesignConfig;
const getContentWidthFromDesignConfig = (designConfig) => {
    const waypointRoot = designConfig?.["root"];
    if (waypointRoot) {
        return undefined;
    }
    const unlayerConfig = designConfig;
    // Check body.values.contentWidth first (common location)
    const bodyContentWidth = unlayerConfig?.["body"]?.["values"]?.["contentWidth"];
    if (bodyContentWidth) {
        return bodyContentWidth;
    }
    // Fall back to root level contentWidth
    return unlayerConfig?.["contentWidth"] ?? undefined;
};
exports.getContentWidthFromDesignConfig = getContentWidthFromDesignConfig;
